import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Notifications_view extends PureComponent {
  render() {
    return (
      <div className="row" id="notifications_view">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>View Notifications</h2>
              <p>
                You can only view your own notifications. The notification view
                function returns two arrays an array of read notifications and
                an array of a unread notifications. Both arrays will return a
                maximum of 20 results and will automatically sort in youngest to
                oldest order.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>View Notifications Example</h2>
              <p>This example is a standard notification get.</p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodeGET">GET</span> - https://
                <span className="jsonY">example</span>
                .api.nexoid.com/v1/notification?session_id=
                <span className="jsonO">
                  &#123;&#123;session_id&#125;&#125;
                </span>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123; &#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"unread"</span>: [
                </div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"id"</span>:{" "}
                  <span className="jsonY">"521"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"title"</span>:{" "}
                  <span className="jsonY">"INC-75 was assigned to you"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"description"</span>:{" "}
                  <span className="jsonY">
                    "Sally Peterson assigned you a ticket."
                  </span>
                  ,
                </div>
                <div className="i4">
                  <span className="jsonG">"link"</span>:{" "}
                  <span className="jsonY">"record/incident/INC-75"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"icon"</span>:{" "}
                  <span className="jsonY">"headset_mic"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"icon_color"</span>:{" "}
                  <span className="jsonY">"#FFD54F"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"icon_color_background"</span>:{" "}
                  <span className="jsonY">"#1976D2"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"created"</span>:{" "}
                  <span className="jsonY">"2016-08-18T21:50:34.094Z"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"updated"</span>:{" "}
                  <span className="jsonY">"2016-08-18T21:50:34.094Z"</span>
                </div>
                <div className="i3">&#125;</div>
                <div className="i2">&#125;</div>
                <div className="i1">],</div>
                <div className="i1">
                  <span className="jsonG">"read"</span>: [
                </div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"id"</span>:{" "}
                  <span className="jsonY">"486"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"title"</span>:{" "}
                  <span className="jsonY">"INC-62 was assigned to you"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"description"</span>:{" "}
                  <span className="jsonY">
                    "Patrick Robberts assigned you a ticket."
                  </span>
                  ,
                </div>
                <div className="i4">
                  <span className="jsonG">"link"</span>:{" "}
                  <span className="jsonY">"record/incident/INC-62"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"icon"</span>:{" "}
                  <span className="jsonY">"headset_mic"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"icon_color"</span>:{" "}
                  <span className="jsonY">"#FFD54F"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"icon_color_background"</span>:{" "}
                  <span className="jsonY">"#1976D2"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"created"</span>:{" "}
                  <span className="jsonY">"2016-08-18T21:50:34.094Z"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"updated"</span>:{" "}
                  <span className="jsonY">"2016-08-18T22:03:09.851Z"</span>
                </div>
                <div className="i3">&#125;</div>
                <div className="i2">&#125;</div>
                <div className="i1">]</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Notifications_view;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Notifications_view.js